<script>
  import { List } from 'lucide-svelte';

  export let iconClass = '';
</script>

<List class={iconClass} />
